import service from './index'

const allTags = service.resource('tags/all-tags')
const runnerTags = service.resource('tags/runner-tags{/runnerId}')
const addRunnerTags = service.resource('tags/add-runner-tag/{runnerId}/{tagId}')
const removeRunnerTags = service.resource('tags/remove-runner-tag/{runnerId}/{tagId}')
const createNewTag = service.resource('tags/create')
const raceTags = service.resource('tags/race-tags{/raceId}')
const addRaceTags = service.resource('tags/add-race-tag/{raceId}/{tagId}')
const removeRaceTags = service.resource('tags/remove-race-tag/{raceId}/{tagId}')
const addPromoTag = service.resource('tags/add-promocode-tag/{promoCodeId}/{tagId}')
const removePromoTag = service.resource('tags/remove-promocode-tag/{promoCodeId}/{tagId}')

export default {
  getAllTags(){
    return allTags.get()
  },
  createTag(data){
    return createNewTag.save(data)
  },
  getRunnerTags (runnerId) {
    return runnerTags.get({runnerId: runnerId})
  },
  addRunnerTag(runnerId,tagId){
     //POST - /api/tags/add-runner-tag/:runnerId/:tagId  
     return addRunnerTags.save({runnerId: runnerId,tagId:tagId},{})
  },
  removeRunnerTags(runnerId,tagId){
    return removeRunnerTags.delete({runnerId: runnerId,tagId:tagId})
  },  
  getRaceTags (raceId) {
    return raceTags.get({raceId: raceId})
  },
  addRaceTag(raceId,tagId){
    //POST - /api/tags/add-race-tag/:raceId/:tagId 
    return addRaceTags.save({raceId: raceId,tagId:tagId},{})
  },
  removeRaceTag(raceId,tagId){
    return removeRaceTags.delete({raceId: raceId,tagId:tagId})
  }, 
  addPromoTag(promoCodeId,tagId){
    //  POST - /add-promocode-tag/{promoCodeId}/{tagId}
    return addPromoTag.save({promoCodeId: promoCodeId,tagId:tagId},{})
  },
  removePromoTag(promoCodeId,tagId){
    //DELETE - /remove-promocode-tag/{promoCodeId}/{tagId}
    return removePromoTag.delete({promoCodeId: promoCodeId,tagId:tagId})
  }, 
  


 

  
  
}




// WEBPACK FOOTER //
// ./src/services/tag.js